module.exports = {"341323100":"灵城镇","341323101":"韦集镇","341323102":"黄湾镇","341323103":"娄庄镇","341323104":"杨疃镇","341323105":"尹集镇","341323106":"浍沟镇","341323107":"游集镇","341323108":"下楼镇","341323109":"朝阳镇","341323110":"渔沟镇","341323111":"高楼镇","341323112":"冯庙镇","341323200":"向阳乡","341323201":"朱集乡","341323202":"大路乡","341323203":"大庙乡","341323204":"禅堂乡","341323205":"虞姬乡","341323400":"灵璧县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341323.json
// module id = 1133
// module chunks = 0